import styled from "styled-components";
import { Drawer, IconButton } from "@material-ui/core";
import { sidebarColours } from "./common_styles";

const TRANSITION = "200ms cubic-bezier(0.4, 0, 0.2, 1)";

export const DrawerRoot = styled(Drawer)`
    /* Style the MUI Drawer paper */
    & .MuiDrawer-paper {
        overflow-x: hidden;
        transition: width ${TRANSITION};
        will-change: width;
        background: ${sidebarColours.bg};
        color: ${sidebarColours.text};
    }
`;

export const Gutter = styled.div`
  flex: 0 0 auto;
  width: ${(p) => (typeof p.$width === "number" ? `${p.$width}px` : "0")};
  height: 100vh;
  pointer-events: none;

  transition: width ${TRANSITION};
  will-change: width;
`;

/* One column does both jobs (wrapper + inner column) */
export const Column = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const BrandWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    height: 56px;
    padding: 0 16px;
    color: ${sidebarColours.textStrong};
    border-bottom: 1px solid ${sidebarColours.divider};
    flex-shrink: 0;
`;

export const BrandRow = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
    gap: 10px;
`;

export const LogoOnlyWrap = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LogoImg = styled.img`
    display: block;
    height: 22px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    object-position: left;
`;

export const Product = styled.div`
    font-weight: 700;
    letter-spacing: 0.2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
`;

export const RailScroll = styled.div`
    flex: 1;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding-top: 12px; /* breathing room above "All Workspaces" */

    & .MuiList-padding {
        padding-top: 0;
        padding-bottom: 0;
    }
    & .MuiDivider-root {
        border-color: ${sidebarColours.divider};
    }
`;

export const FooterToggle = styled.div`
    position: sticky;
    bottom: 0;
    padding: 12px;
    display: flex;
    justify-content: flex-start;
    border-top: 1px solid ${sidebarColours.divider};
    background: ${sidebarColours.bg};
`;

export const ToggleBtn = styled(IconButton)`
    && {
        color: ${sidebarColours.text};
        padding: 6px;
        border-radius: 8px;
        outline: none !important;
        box-shadow: none;

        &:focus {
            outline: none;
            box-shadow: none;
        }
        &.Mui-focusVisible {
            box-shadow: 0 0 0 2px ${sidebarColours.focusBar};
            background: rgba(255, 255, 255, 0.04);
        }
        &::-moz-focus-inner {
            border: 0;
        }
        &:hover {
            background: ${sidebarColours.hover};
        }
    }
`;
